export default "__VITE_ASSET__CT$5kYFK__"